<template>
  <slot></slot>

  <template v-if="isContactFormLoaded">
    <ContactFormDialog
      v-model:success="success"
      :subject="contactFormData?.subject"
      :message="contactFormData?.message"
      :additional-information="contactFormData?.additionalInformation"
      :is-open="isContactFormOpen"
      @on-request-close="close"
    />
  </template>
</template>

<script setup lang="ts">
import { defineAsyncComponent } from 'vue'

import { setupContactForm } from './'

const ContactFormDialog = defineAsyncComponent(() => import('./ContactFormDialog.vue'))

const { isContactFormLoaded, isContactFormOpen, contactFormData, success, close } =
  setupContactForm()
</script>
